export default __webpack_public_path__ + "static/media/loading-housi.ea98522d.gif";